import setFullbanner from './home/1_fullbanner';
import setIconsHorizontal from './home/icons_horizontal';
import setBannerCategoria from './home/categories';
import setCarousel from '../components/carousel';
import handleConditionalLazy from '../components/conditionalLazy';
import setQuotationSwiper from './home/quotation';
import setBannerLinha from './home/home_banner_linha';
import storesTabs from './home/stores_tabs';

//addImports

import setTopBar from '../components/topBar';
import ReactiveSearch from '../components/reactiveSearch';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();
    ReactiveSearch.init();

    setFullbanner();
    setIconsHorizontal();
    setBannerCategoria();
    setCarousel();
    setQuotationSwiper();
    setBannerLinha();
    storesTabs();

    //calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
